module.exports = __webpack_public_path__ + "static/media/pickQuestionSelected.4d679978.svg";